import { LoginPage } from "../pages/loginPage";
import { Route, Routes } from "react-router-dom";
import { AppLayout } from "../components/containers/appLayout/AppLayout";
import { ResetPassword } from "../pages/ResetPassword";
import { ResetPasswordDone } from "../pages/ResetPasswordDone";
import { RequireAuthWrapper } from "../pages/RequireAuthWrapper";
import { LandingPage } from "../pages/landingPage";

export const LoginRoutes = () => {
  return (
    <Routes>
      <Route path={""} element={<LoginPage />} />
      <Route
        path={""}
        element={
          <RequireAuthWrapper>
            <AppLayout pageTitle={""}>
              <LandingPage />
            </AppLayout>
          </RequireAuthWrapper>
        }
      />
      <Route path={"password-reset"}>
        <Route
          path={""}
          element={
            <AppLayout pageTitle={"Password Reset"}>
              <ResetPassword />
            </AppLayout>
          }
        />
        <Route
          path={"done"}
          element={
            <AppLayout pageTitle={"Done"}>
              <ResetPasswordDone />
            </AppLayout>
          }
        />
      </Route>
    </Routes>
  );
};
